
// src/connects/group-templates-panel.js

import { connect } from 'react-redux'
import ui from '../helpers/ui-state'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { trackPage, trackHandlers } from '../helpers/analytics'
import { emitAlertMessage } from '../actions/alert-message'

export const mapStateToProps = (state)=> {
  return {
    templates: state.templates.items,
    isFetching: state.templates.isFetching,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    editTemplate: (props, template_id)=> ownProps.selectPanel('templates', 'edit', { template_id }),
    newTemplate: (props, cloneTemplate = undefined)=> ownProps.selectPanel('templates', 'new', { template_id: undefined, type: 'group', id: props.group.group_id, cloneTemplate}),
    deleteTemplate: (template)=> {
      dispatch(actions.deleteTemplate(template.template_id))
      dispatch(emitAlertMessage({ message: "label:テンプレートを削除しました", name: template.name }, "success"))
    },
    willMount: (props)=> dispatch(actions.fetchTemplates(props.group.group_id, 'group')),
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle,
  translate(),
  trackPage('group_templates'),
  trackHandlers('editTemplate', 'group_template_edit'),
  trackHandlers('newTemplate', 'group_template_new'),
)



// WEBPACK FOOTER //
// ./src/connects/group-templates-panel.js